module.exports = __webpack_public_path__ + "static/img/WechatIMG254.2b054fc9.jpeg";